import { addDays } from 'date-fns'
import { announcementPersistentDomain } from '../domain/announcement-domain'

export const hasAnnouncementBeenViewedWithinDays = (popupId: number, days: number) => {
    const viewedDate = announcementPersistentDomain.data.viewed[popupId]

    if (!viewedDate) {
        return false
    }

    return addDays(viewedDate, days) > new Date()
}
